import api from "../lib/api";
import { ChartLayoutConfig } from "../models/company.model";

export async function getChartConfig() {
  const data = await api<{ chartConfig: ChartLayoutConfig | undefined }>({
    url: `/chart-configs`,
    method: "GET",
  });
  return data.chartConfig;
}
